// What the signed-in user may do. Permissions come from the API at login and
// are refreshed from /auth/me whenever the app loads, so a role edit reaches
// the menus within a minute. The API enforces the same keys — hiding a
// button is a courtesy, not the security.
import api from './api';

// Someone signed in before roles existed has no perms list yet; until the
// refresh lands, treat them as the old Depot Staff set (admins as everything).
const LEGACY_DEPOT = [
  'parcels.view', 'parcels.book', 'parcels.assign',
  'clients.view', 'clients.create', 'clients.edit',
  'billing.view', 'billing.invoice', 'billing.payments', 'billing.statements',
  'labels.manage',
];

export function currentUser() {
  try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
}

export function can(key) {
  const u = currentUser();
  if (u.role === 'admin') return true;
  if (Array.isArray(u.perms)) return u.perms.includes(key);
  return u.role === 'depot' && LEGACY_DEPOT.includes(key);
}

export const canAny = (keys) => keys.some(can);

// Pull fresh role + permissions and keep them in localStorage
export async function refreshUser() {
  const { data } = await api.get('/auth/me');
  const merged = { ...currentUser(), ...data };
  localStorage.setItem('user', JSON.stringify(merged));
  return merged;
}
